import { render, staticRenderFns } from "./HoursRealMonthWidget.vue?vue&type=template&id=3137e0e2&"
import script from "./HoursRealMonthWidget.vue?vue&type=script&lang=js&"
export * from "./HoursRealMonthWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports